function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
export default function formatPrice(value) {
  var showCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ",";

  if ([0, "0"].includes(value)) {
    return "0";
  }

  if (!value) {
    return "";
  }

  var parsedPrice = value.toString().split(/[,.]/g);

  var _parsedPrice = _slicedToArray(parsedPrice, 1),
      dollars = _parsedPrice[0];

  var _parsedPrice2 = _slicedToArray(parsedPrice, 2),
      _parsedPrice2$ = _parsedPrice2[1],
      cents = _parsedPrice2$ === void 0 ? "" : _parsedPrice2$;

  var _cents = _slicedToArray(cents, 2),
      _cents$ = _cents[0],
      cent1 = _cents$ === void 0 ? "0" : _cents$,
      _cents$2 = _cents[1],
      cent2 = _cents$2 === void 0 ? "0" : _cents$2;

  dollars = dollars.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");

  if (!showCents) {
    return dollars;
  }

  return "".concat(dollars).concat(separator).concat(cent1).concat(cent2);
}